import {Component, Input, OnDestroy, OnInit, inject} from '@angular/core';
import {Subscription} from 'rxjs';
import {Script, Patient, FilesRepositoryService} from '@xmedical/core';
import {PatientScriptsStore} from 'src/app/core/state/patient-scripts.store';
import {PatientStore, PracticeStore} from 'src/app/core/state';
import {CoreService} from 'src/app/core/services/core.service';

@Component({
    selector: 'app-script-widget',
    templateUrl: './script-widget.component.html',
    styleUrls: ['./script-widget.component.scss'],
    standalone: false
})
export class ScriptWidgetComponent implements OnInit, OnDestroy {

  @Input() script: Script;
  printing = false;
  private filesRepositorySubscription: Subscription;

  private scriptsStore = inject(PatientScriptsStore);
  private patientStore = inject(PatientStore);
  private practiceStore = inject(PracticeStore);
  private coreService = inject(CoreService);
  private filesRepository = inject(FilesRepositoryService);

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filesRepositorySubscription) { this.filesRepositorySubscription.unsubscribe(); }
  }


  get patientId(): number {
    return this.patientStore.current()!.id;
  }

  get patient(): Patient {
    return this.patientStore.current()!;
  }

  get confirmationMessage(): string {
    return 'Are you sure you wish to print this script?';
  }

  print(id: number) {
    this.printing = true;
    this.filesRepositorySubscription = this.filesRepository.getUrl('script', id, this.patientId).subscribe(
      url => {
        window.open(url, '_blank');
        this.printing = false;
        this.scriptsStore.reload();
      }, error => {
        console.error(error);
        this.printing = false;
      });
  }

  get canDelete(): boolean {
    // Auto-locked, never-printed scripts (e.g. chronic / hemodialysis /
    // erythropoietin). Backend re-validates; drafts go through the existing
    // edit/delete flow elsewhere. Gated on the practice-wide toggle so the
    // action only surfaces where practices have opted in.
    if (!this.practiceStore.practiceSettings()?.deleteUnprintedClinicalItemsEnabled) return false;
    return !!(this.script?.locked && !this.script?.printed);
  }

  get deleteConfirmationMessage(): string {
    return 'Delete this script? This cannot be undone.';
  }

  delete(id: number): void {
    this.scriptsStore.delete(id).subscribe({
      error: () => this.coreService.showErrorToast('Could not delete this script')
    });
  }
}
